"use client";

import { useEffect, useState } from "react";
import { images } from "@/config/images";
import Image from "next/image";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi,
} from "@/components/ui/carousel";
import { Caption, Headline6 } from "./typography";

export function BackedBySection() {
  const [api, setApi] = useState<CarouselApi>();

  useEffect(() => {
    if (!api) return;

    const autoplay = setInterval(() => {
      api.scrollNext();
    }, 2000);

    return () => clearInterval(autoplay);
  }, [api]);

  return (
    <section className=" bg-spicenet-black py-16 md:py-24 ">
      <div className=" mx-auto px-4 md:px-6 ">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-medium tracking-[-1.5px] text-white mb-4">
            Backed by the Best
          </h2>
          <Headline6 className="text-xs md:text-sm  text-white/70 ">
            Explore the Spicenet investors: Discover opportunities, connect with
            visionary backers,
            <br />
            and grow your network!
          </Headline6>
        </div>

        {/* Top divider with INVESTORS label */}
        <div className="relative mb-12">
          <div className="h-px bg-white" />
          <div className="absolute left-0 top-1/2 -translate-y-1/2 bg-spicenet-black pr-8">
            <Caption className="text-white ">
              INVESTORS
            </Caption>
          </div>
        </div>

        {/* Scrolling Investors Container */}
        <div className="mb-12 py-8 max-w-[80vw] mx-auto">
          <Carousel
            opts={{
              loop: true,
              align: "start",
            }}
            setApi={setApi}
          >
            <CarouselContent className="-ml-4">
              {images.investors.map((investor, index) => (
                <CarouselItem
                  key={index}
                  className="basis-1/1 md:basis-1/3 lg:basis-1/4 pl-4"
                >
                  <div className="flex items-center justify-center h-12">
                    {investor.logo ? (
                      investor.url ? (
                        <a
                          href={investor.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block"
                        >
                          <Image
                            src={investor.logo}
                            alt={investor.name}
                            width={140}
                            height={50}
                            className="h-12 w-auto object-contain brightness-0 invert opacity-70 hover:opacity-100 transition-opacity duration-200"
                          />
                        </a>
                      ) : (
                        <Image
                          src={investor.logo}
                          alt={investor.name}
                          width={140}
                          height={50}
                          className="h-12 w-auto object-contain brightness-0 invert opacity-70 hover:opacity-100 transition-opacity duration-200"
                        />
                      )
                    ) : (
                      <div className="flex flex-col min-w-[200px]">
                        <p className="text-white text-2xl font-normal mb-1">
                          {investor.name}
                        </p>
                        {investor.subtitle && (
                          <p className="text-white/50 text-xs uppercase tracking-[0.2em] font-mono tracking-[0px]!">
                            {investor.subtitle}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>

        {/* Bottom divider with button */}
        <div className="relative">
          <div className="h-px bg-white" />
          <div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 bg-spicenet-black px-4">
            <Link href="/ecosystem">
              <Button variant="monochrome" size="default">
                Ecosystem Page
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
